import useFormat from '../../hooks/useFormat';

import TaxonomyPage, { TaxonomyPageProps } from './TaxonomyPage';

interface FormatPageProps extends TaxonomyPageProps {
    slug: string;
}

function FormatPage({ slug, ...props }: FormatPageProps) {
    const { format = null, notFound = false } = useFormat(slug);

    return <TaxonomyPage taxonomy={format} notFound={notFound} {...props} />;
}

export default FormatPage;
